import { defineMessages } from 'react-intl'

const scope = `procurify.modules.purchasing.feature-sets.po-disclaimer-labels-view`

export default defineMessages({
  heading: {
    id: `${scope}.heading`,
    defaultMessage: 'Purchase order disclaimer/labels',
  },
  description: {
    id: `${scope}.description`,
    defaultMessage:
      'Purchase order disclaimer/labels are {optional} labels that can be chosen when creating a purchase order. It states additional information/disclaimer you wish to convey to the recipient at the bottom of the purchase order.',
  },
  descriptionOptional: {
    id: `${scope}.descriptionOptional`,
    defaultMessage: 'optional',
  },
  newLabelButton: {
    id: `${scope}.newLabelButton`,
    defaultMessage: 'New label',
  },
  createModalTitle: {
    id: `${scope}.createModalTitle`,
    defaultMessage: 'Create label',
  },
})
